import router from './router'
import store from './store'

const whiteList = [
  '/login',
]

const checkWhitePath = function (path) {
  if (whiteList.indexOf(path) >= 0) {
    return true
  }
  return false
}

router.beforeEach(async (to, from, next) => {
  const hasToken = store.getters.token
  const userId = store.getters.userId
  if (hasToken && userId) {
    if (to.path === '/login') {
      next({path: '/home'})
    } else {
      if (store.getters.menu && store.getters.menu.length > 0) {
        next()
      } else {
        await store.dispatch('user/initMenu')
        next({...to, replace: true})
      }
    }
  } else {
    if (checkWhitePath(to.path)) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
    }
  }
})

router.afterEach(() => {
  // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js